/**
* @file 业务管理-规则配置
* */
<template>
  <div id="settingFrame">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "rules",
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({'buttonsGetter': 'buttonsGetter'})
  },
  watch: {
    tabAction() {
      this.$router.push(this.tabAction);
    },
    $route: {
      handler(val) {
        if (val.path == '/rulesConfig') {

            let tabs = [];
            if (this.menuPreFn(85)) tabs.push({label: "计价规则", name: "/hitchRidePricingRule", icon: 'el-icon-price-tag'});
            if (this.menuPreFn(100)) tabs.push({label: "销单规则", name: "/hitchRideCancelRule", icon: 'el-icon-circle-close'});
            if (this.menuPreFn(94)) tabs.push({label: "抽成规则", name: this.mixinUserInfo.platformType == 3 ? "/hitchRideSettleRule" : "/airportCommissionRule", icon: 'el-icon-s-finance'});
            if (this.menuPreFn(101)) tabs.push({label: "提现规则", name: "/hitchRideWithdrawalRule", icon: 'el-icon-wallet'});
            if (this.menuPreFn(117)) tabs.push({label: "业务提现", name: "/dispatchWithdrawalRule", icon: 'el-icon-money'});
            if (this.menuPreFn(118)) tabs.push({label: "司机提现", name: "/driverWithdrawalRule", icon: 'el-icon-user'});
            if (this.menuPreFn(104)) tabs.push({label: "车主认证", name: "/hitchRideDriverAuditRule", icon: 'el-icon-s-check'});
            this.tabs = tabs;
            this.tabAction = this.tabAction ?this.tabAction : tabs[0].name
            this.$router.push(this.tabAction);
            return
          }
          this.tabAction = val.path;
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.mixinOrganizations();
    let tabs = [];

    console.log(this.menuPreFn(94),3232323);
    setTimeout(() => {
      if (this.menuPreFn(85)) tabs.push({label: "计价规则", name: "/hitchRidePricingRule", icon: 'el-icon-price-tag'});
            if (this.menuPreFn(100)) tabs.push({label: "销单规则", name: "/hitchRideCancelRule", icon: 'el-icon-circle-close'});
            if (this.menuPreFn(94)) tabs.push({label: "抽成规则", name: this.mixinUserInfo.platformType == 3 ? "/hitchRideSettleRule" : "/airportCommissionRule", icon: 'el-icon-s-finance'});
            if (this.menuPreFn(101)) tabs.push({label: "提现规则", name: "/hitchRideWithdrawalRule", icon: 'el-icon-wallet'});
            if (this.menuPreFn(117)) tabs.push({label: "业务提现", name: "/dispatchWithdrawalRule", icon: 'el-icon-money'});
            if (this.menuPreFn(118)) tabs.push({label: "司机提现", name: "/driverWithdrawalRule", icon: 'el-icon-user'});
            if (this.menuPreFn(104)) tabs.push({label: "车主认证", name: "/hitchRideDriverAuditRule", icon: 'el-icon-s-check'});

      console.log(tabs,322);
      this.tabs = tabs;
      // this.tabAction = tabs[0].name
      this.tabAction = this.tabAction && this.tabAction != '/settingFrame' ? this.tabAction : tabs[0].name;
    }, Object.values(this.buttonsGetter ? this.buttonsGetter : {}).length > 0 ? 0 : 1500);
  },
};
</script>

<style lang="less">
#settingFrame {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    & > div {
      height: 100%;
    }
  }
}
</style>
